module.exports = __webpack_public_path__ + "static/img/Round-15-2013.b2bb659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-15-2013.jpg
// module id = KguQ
// module chunks = 0